import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const LiveIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 12 9"
    width={width}
    {...restProps}
  >
    <g>
      <path d="M2.60567 0.178938C2.83992 0.417522 2.83992 0.804344 2.60567 1.04293C0.731031 2.95222 0.731031 6.04778 2.60567 7.95707C2.83992 8.19566 2.83992 8.58248 2.60567 8.82106C2.37141 9.05965 1.99161 9.05965 1.75736 8.82106C-0.585786 6.43461 -0.585786 2.56539 1.75736 0.178938C1.99161 -0.059646 2.37141 -0.059646 2.60567 0.178938ZM10.2426 0.178938C12.5858 2.56539 12.5858 6.43461 10.2426 8.82106C10.0084 9.05965 9.62858 9.05965 9.39433 8.82106C9.16008 8.58248 9.16008 8.19566 9.39433 7.95707C11.269 6.04778 11.269 2.95222 9.39433 1.04293C9.16008 0.804344 9.16008 0.417522 9.39433 0.178938C9.62858 -0.059646 10.0084 -0.059646 10.2426 0.178938ZM4.3852 1.93438C4.61945 2.17296 4.61945 2.55978 4.3852 2.79837C3.46686 3.73368 3.46686 5.25013 4.3852 6.18544C4.61945 6.42403 4.61945 6.81085 4.3852 7.04943C4.15095 7.28802 3.77114 7.28802 3.53689 7.04943C2.15004 5.63695 2.15004 3.34686 3.53689 1.93438C3.77114 1.69579 4.15095 1.69579 4.3852 1.93438ZM8.55912 1.93438C9.94596 3.34686 9.94596 5.63695 8.55912 7.04943C8.32486 7.28802 7.94506 7.28802 7.71081 7.04943C7.47655 6.81085 7.47655 6.42403 7.71081 6.18544C8.62915 5.25013 8.62915 3.73368 7.71081 2.79837C7.47655 2.55978 7.47655 2.17296 7.71081 1.93438C7.94506 1.69579 8.32486 1.69579 8.55912 1.93438ZM6.048 3.62631C6.54493 3.62631 6.94777 4.0366 6.94777 4.54271C6.94777 5.04882 6.54493 5.45911 6.048 5.45911C5.55107 5.45911 5.14823 5.04882 5.14823 4.54271C5.14823 4.0366 5.55107 3.62631 6.048 3.62631Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

LiveIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default LiveIcon;
